import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import globals from '../../../assets/styles/globals.scss'
import LandingHeader from '../../common/LandingHeader'
import ExistingCommunityErrorSection from './ExistingCommunityErrorSection'
import CodeSection from './CodeSection'
import TooltipText from '../../common/TooltipText'

import classes from './AccessCodeRequired.module.scss'

const AccessCodeRequired = () => {
  const { t } = useTranslation()
  const user = useSelector(state => state.user.current_user)
  const { community } = useSelector(state => state.landingAccess)

  return (
    <>
      <LandingHeader />

      <div className='w-100'>
        <div className={classNames(classes.accessCodeRequiredContent, 'd-flex flex-column flex-lg-row')}>
          <section className={classNames(classes.mainSection, 'flex-grow-1 flex-lg-shrink-0 order-2 order-lg-1')}>
            {user?.communities?.[0]?.id ? (
              <ExistingCommunityErrorSection />
            ) : (
              <CodeSection />
            )}
          </section>

          <section className={classNames(classes.communitySection, 'flex-shrink-0 order-1 order-lg-2')}>
            <div
              style={{
                background: community.headerImage
                  ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${community?.headerImage?.fileUrl}) center/cover no-repeat`
                  : globals.darkNavy,
              }}
              className={classNames(classes.communityWrapper, 'h-100 d-flex flex-row flex-lg-column justify-content-center align-items-center')}
            >
              <div className={classNames(classes.communityPhoto, 'large-round-image-wrapper')}>
                <img className='round-image' src={community.photo?.originalFileUrl} alt={t('programs.accessCode.communityAvatarAlt')} />
              </div>

              <h1 className={classNames('ml-3 ml-lg-0 m-0', classes.nameText)}>{community.name}</h1>
              <TooltipText className={classNames('d-none d-lg-block mt-4', classes.addressText)} text={community.address.name} />
            </div>
          </section>
        </div>
      </div>
    </>
  )
}

export default AccessCodeRequired
